import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  address: Yup.string()
    .max(40, 'Polje može da sadrži maksimalno 40 karaktera.')
    .required('Unesite naziv ulice.'),
  fieldType: Yup.string().required('Odaberite jednu od ponuđenih opcija.'),
  locationComponent: Yup.string().required(
    'Odaberite jednu od ponuđenih opcija.'
  ),
  dma: Yup.string().required('Odaberite jednu od ponuđenih opcija.'),
  image: Yup.mixed()
    .notRequired()
    .test(
      'FILE_SIZE',
      'Veličina datoteke je prevelika. Maksimalna veličina datoteke je 10MB.',

      (value) => {
        if (!value || value === '') return true;
        return value && value.size < 1024 * 1024 * 10;
      }
    )
    .test(
      'FILE_TYPE',
      'Nepodržan format datoteke. Dozvoljeni su samo JPG, JPEG i PNG formati.',
      (value) => {
        if (!value || value === '') return true;

        return (
          value && ['image/png', 'image/jpeg', 'image/jpg'].includes(value.type)
        );
      }
    ),
});

export const initialValues = {
  address: '',
  description: '',
  image: '',
  fieldType: '',
  locationComponent: '',
  dma: '',
  suggestion: '',
};
